// AUTO-GENERATED from docs/TECHNICAL_PRD.md — CID Agent PWA API layer
// Module: Profile & Settings (self-edit contact/bank/personal, documents, REN, preferences)
// Every list (collection GET) takes params { page, limit, ...filters }.
import client from './client';

/**
 * GET /api/agent/me [LIST · paginated]
 * Return the caller's own profile: editable fields plus read-only display fields (name, REN, tier, rank, branch name). Backs the Profile screen header and edit form.
 * @disposition ADAPT_SCOPE · maps to GET /agents/:id (agentService.getAgentById)
 */
export const listMe = (params = {}) => client.get(`/api/agent/me`, { params });

/**
 * PUT /api/agent/me
 * Field-whitelisted self-edit of contact/address/bank/emergency/personal/tax/REN-renewal details. Must NOT reuse updateAgent (mass-assignment + recruiter-count side effects + governance writes).
 * @disposition BUILD_NEW · maps to PUT /agents/:id (agentService.updateAgent)
 */
export const updateMe = (data = {}) => client.put(`/api/agent/me`, data);

/**
 * PUT /api/agent/me/visibility
 * Marketing/display consent toggles: opt in/out of the public leaderboard display and public website listing. Kept separate from PUT /me so the policy-gated toggles are isolated and auditable.
 * @disposition BUILD_NEW · maps to PUT /agents/:id (leaderboard, website columns)
 */
export const updateMeVisibility = (data = {}) => client.put(`/api/agent/me/visibility`, data);

/**
 * POST /api/agent/me/profile-picture
 * Upload/replace own avatar. Multipart image -> storage -> writes agents.profile_picture_url.
 * @disposition ADAPT_SCOPE · maps to POST /agents/:id/profile-picture (controller.uploadProfilePicture)
 */
export const createMeProfilePicture = (data = {}) => client.post(`/api/agent/me/profile-picture`, data);

/**
 * GET /api/agent/me/documents [LIST · paginated]
 * List own supporting documents (IC/passport copies, certs, REN license) with short-lived signed download URLs.
 * @disposition ADAPT_SCOPE · maps to GET /agents/:id/attachments (agentService.listAttachments)
 */
export const listMeDocuments = (params = {}) => client.get(`/api/agent/me/documents`, { params });

/**
 * POST /api/agent/me/documents/upload-url
 * Get a signed direct-to-storage upload URL for a new document (mirrors the sale-attachment flow).
 * @disposition ADAPT_SCOPE · maps to POST /agents/:id/attachments/upload-url (generateAttachmentUploadUrl)
 */
export const createMeDocumentsUploadUrl = (data = {}) => client.post(`/api/agent/me/documents/upload-url`, data);

/**
 * POST /api/agent/me/documents/confirm
 * Record the uploaded document metadata after the client PUTs the file to storage.
 * @disposition ADAPT_SCOPE · maps to POST /agents/:id/attachments/confirm-upload (confirmAttachmentUpload)
 */
export const createMeDocumentsConfirm = (data = {}) => client.post(`/api/agent/me/documents/confirm`, data);

/**
 * DELETE /api/agent/me/documents/:attachmentId
 * Delete one of the caller's own documents (storage object + row).
 * @disposition ADAPT_SCOPE · maps to DELETE /agents/:id/attachments/:attachmentId (deleteAttachment)
 */
export const deleteMeDocumentsByAttachmentId = (attachmentId, config = {}) => client.delete(`/api/agent/me/documents/${attachmentId}`, config);

/**
 * GET /api/agent/me/ren [LIST · paginated]
 * Read-only REN license status + expiry, with a computed expiry countdown for the renewal reminder UI.
 * @disposition BUILD_NEW · maps to NEW (derived subset of agents REN columns)
 */
export const listMeRen = (params = {}) => client.get(`/api/agent/me/ren`, { params });

/**
 * PUT /api/agent/me/password
 * Change own password while logged in (verify current, set new, revoke sessions).
 * @disposition BUILD_NEW · maps to PUT /auth/me/password (authService.changePassword)
 */
export const updateMePassword = (data = {}) => client.put(`/api/agent/me/password`, data);

/**
 * GET /api/agent/me/preferences [LIST · paginated]
 * Read client + server preferences: theme and notification opt-ins.
 * @disposition BUILD_NEW
 */
export const listMePreferences = (params = {}) => client.get(`/api/agent/me/preferences`, { params });

/**
 * PUT /api/agent/me/preferences
 * Update theme and notification preferences (upsert one row per agent).
 * @disposition BUILD_NEW
 */
export const updateMePreferences = (data = {}) => client.put(`/api/agent/me/preferences`, data);
